export default __webpack_public_path__ + "static/media/finger.55a73b10.svg";